var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quiz" }, [
    _c("div", { staticClass: "quiz__inner" }, [
      _c("h2", { staticClass: "quiz__header heading-secondary" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(_vm.currentScreen, {
            tag: "component",
            attrs: {
              question: _vm.currentQuestion,
              answers: _vm.currentAnswerKeys,
              showBackButton:
                _vm.currentScreenIndex > 1 && _vm.currentScreenIndex !== 6,
              totalPages: _vm.totalPages,
              currentPage: _vm.currentScreenIndex,
            },
            on: {
              updateInLocalStorage: _vm.updateInLocalStorage,
              next: _vm.handleNext,
              back: _vm.handleBack,
              restart: _vm.resetQuiz,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }